export const CLIENT_PAGES = {
  dashboard: '/client/dashboard',
  programDashboard: '/client/dashboard/program',
  orders: '/client/orders',
  myProfile: '/client/my-profile',
  users: '/client/users',
  theme: '/client/theme',
  addUser: '/client/users/add-user',
  placeOrder: '/client/orders/new',
  placeDropShipmentOrder: '/client/orders/new/ds',
  kitRegistration: '/client/kit-registration',
  eligibilityQuestionnaireBuilder: '/client/eligibility-questionnaire-builder',
} as const

export type ClientPagePath = (typeof CLIENT_PAGES)[keyof typeof CLIENT_PAGES]
